import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { get, forEach } from 'lodash'
import cn from 'classnames'
import moment from 'moment'
import { toast } from 'react-toastify'

import Navbar from '../containers/Navbar'

import Button from '../components/Button'
import styles from './DebugInfo.module.scss'
import { Box, Switch, Typography } from '@material-ui/core'

import { getMaintenancedAt } from '../selectors/order'
import { getSafIsUploading } from '../selectors/peripheral'

import DeviceSubtypes from '../utils/deviceSubtypes'
import PeripheralBridge from '../utils/peripheralBridge'
import { loadConfig, updateConfig } from '@ordernext/networking-stadium/stadium'
import { getFirmwareInfo, getBuildInfo, getTerminalInfo, getPaymentType, PAX_PAYMENT_TYPE, getSafFullResponse } from '../selectors/peripheral'
import { onBuildInfoReceived } from '../actions/peripheral'
import { getDeviceSubtype } from '../selectors/config'
import { getSafResponse, getErrorInfo } from '../selectors/appState'
import { networkSignalSpeed } from '../utils/networkConnected'

import useSafMode from '../hooks/useSafMode'

import SwitchSelector from 'react-switch-selector'

const misMatchElement = (configuredValue, expectedValue) => {
  return (
    <div className={styles.misMatchedValues}>
      <div className={styles.valueColumn}>
        <span>{`${configuredValue}`}</span>
      </div>
    </div>
  )
}

const DebugInfo = ({ loadConfig, updateConfig, config, firmwareInfo, buildInfo, terminalInfo,
    onBuildInfoReceived, secondaryDeviceId, className, deviceType, deviceSubtype,
    maintenancedAt, safResponse, safIsUploading, errorInfo, safFullResponse }) => {
  const classNames = cn(styles.debugInfo, className)
  const [terminalId, setTerminalId] = useState('loading...')
  const [storeId, setStoreId] = useState('loading...')
  const [esKey, setESKey] = useState('loading...')
  const [serviceURL, setServiceURL] = useState('loading...')
  const [terminalIdMatches, setTerminalIdMatches] = useState(true)
  const [storeIdMatches, setStoreIdMatches] = useState(true)
  const [esKeyMatches, setESKeyMatches] = useState(true)
  const [serviceURLMatches, setServiceURLMatches] = useState(true)
  const [configsMatch, setConfigsMatch] = useState(true)

  // for switch between hardware and software view
  const [toggle, setToggle] = useState(true)
  // for toggle switch for offline and online feature
  const [value, setValue] = useState(false)

  const [refreshTimestamp, setRefreshTimestamp] = useState(new Date().toString())
  const [currentPane, setCurrentPane] = useState('device')
  const [signalSpeed, setSignalSpeed] = useState(0)
  const [signalSpeedDisplay, setSignalSpeedDisplay] = useState('Offline')
  const [updateSafMode, getSafModeFromBridge, { safMode }] = useSafMode(null, true)

  const token = localStorage.getItem('accessToken')
  const tokenHeader = token !== null ? JSON.parse(window.atob( token.split('.')[0] )) : undefined
  const tokenPayload = token !== null ? JSON.parse(window.atob( token.split('.')[1] )) : undefined

  useEffect(() => {
    try {
      networkSignalSpeed(setSignalSpeed)
    } catch {
      setSignalSpeed(0)
    }
  }, [])

  const onClickCardReaderCondfiguration = () => {
    const bridgeInstance = PeripheralBridge.getBridge()
    if (!bridgeInstance) return

    bridgeInstance.call('navigateToSettings')
  }

  const onClickViewLogs = () => {
    const bridgeInstance = PeripheralBridge.getBridge()
    if (!bridgeInstance) return

    bridgeInstance.callHandler('getLogs', null, (response) => {
      console.log("FCC LOGS: " + response)
    })
  }

  const handleUseConfigured = () => {
    const bridgeInstance = PeripheralBridge.getBridge()
    if (!bridgeInstance) return

    bridgeInstance.callHandler('getConfig', null, function(response) {
      const terminalId = get(response, 'terminalID')
      const storeId = get(response, 'storeID')
      const esKey = get(response, 'esKey')

      updateConfig({ terminalId, storeId, esKey })
    })
  }

  const handleUseExpected = () => {
    loadConfig()
  }

  const handleOnSafToggle = () => {
    if (safMode !== 3) {
      updateSafMode(3)
    } else {
      updateSafMode(2)
    }
  }

  useEffect(() => {
    const matches = terminalIdMatches && storeIdMatches && esKeyMatches
    setConfigsMatch(matches)
  }, [terminalIdMatches, storeIdMatches, esKeyMatches])

  useEffect(() => {
    if (signalSpeed === 1) {
      setSignalSpeedDisplay('Very Slow')
    } else if (signalSpeed === 2) {
      setSignalSpeedDisplay('Slow')
    } else if (signalSpeed === 3) {
      setSignalSpeedDisplay('Fair')
    } else if (signalSpeed === 4) {
      setSignalSpeedDisplay('Good')
    }
  }, [signalSpeed])

  useEffect(() => {
    const bridgeInstance = PeripheralBridge.getBridge()
    const configurationStatusResolver = (configuredValue, expectedValue, updateValidityMethod, updateValueMethod) => {
      if (configuredValue !== expectedValue) {
        updateValueMethod(misMatchElement(configuredValue, expectedValue))
      } else {
        updateValueMethod(expectedValue)
      }

      updateValidityMethod(configuredValue === expectedValue)
    }

    if (!bridgeInstance) {
      configurationStatusResolver('unavailable', get(config, 'terminalId'), setTerminalIdMatches, setTerminalId)
      configurationStatusResolver('unavailable', get(config, 'storeId'), setStoreIdMatches, setStoreId)
      configurationStatusResolver('unavailable', get(config, 'esKey'), setESKeyMatches, setESKey)
      configurationStatusResolver('unavailable', get(config, 'url'), setServiceURLMatches, setServiceURL)
      return
    }

    bridgeInstance.callHandler('getBuildInfo', null, (response) => {
      onBuildInfoReceived(response)
    })
    bridgeInstance.callHandler('executeTerminalRequest', null)

    bridgeInstance.callHandler('getConfig', null, (response) => {
      const configuredTerminalId = get(response, 'terminalID')
      const configuredStoreId = get(response, 'storeID')
      const configuredESKey = get(response, 'esKey')
      const configuredServiceURL = get(response, 'url')
      const resolverParams = [
        [configuredTerminalId, get(config, 'terminalId'), setTerminalIdMatches, setTerminalId],
        [configuredStoreId, get(config, 'storeId'), setStoreIdMatches, setStoreId],
        [configuredESKey, get(config, 'esKey'), setESKeyMatches, setESKey],
        [configuredServiceURL, get(config, 'url'), setServiceURLMatches, setServiceURL],
      ]

      forEach(resolverParams, (params) => configurationStatusResolver(...params))

    })
  }, [config, refreshTimestamp])

  // Switch Selector
  const options = [
    {
        label: <span>Hardware</span>,
        value: "hardware",
        selectedBackgroundColor: "#2253FF",
    },
    {
        label: <span>Software</span>,
        value: "software",
        selectedBackgroundColor: "#2253FF",
    }
  ];

  const onChange = (newValue) => {
    setToggle(!toggle);
  };

  const initialSelectedIndex = options.findIndex(({value}) => value === "hardware");

  // temp
  const websocketInfo = {
    device_id: localStorage.getItem('device_id'),
    organization_name: process.env.REACT_APP_ORG,
    app_type: null,
    device_name: null,
    locked_at: null,
    presence: null,
  }

  return (
    <div className={styles.debugInfoContainer}>
      <Navbar className={styles.navbar} />

      <div className={styles.selectorContainer}>
          <SwitchSelector
            onChange={onChange}
            options={options}
            initialSelectedIndex={initialSelectedIndex}
            backgroundColor={"#383B3D"}
            selectionIndicatorMargin="6"
          />
      </div>

      {/* Hardware View */}
      {toggle && (
        <div className={classNames}>
          <div className={styles.row}>
            <div className={styles.column}>
              <dl>
                <h3>Device</h3>

                <dt>Signal Speed</dt>
                <dd>{signalSpeedDisplay}</dd>

                <dt>Device ID</dt>
                <dd>{localStorage.getItem('device_id') || 'unknown'}</dd>

                <dt>Secondary Device ID</dt>
                <dd>{secondaryDeviceId || 'unknown'}</dd>

              </dl>
            </div>
            <div className={styles.column}>
              <dl>
                <h3>Card Reader</h3>
                {(deviceType === PAX_PAYMENT_TYPE) && !DeviceSubtypes.isKiosk(deviceSubtype) && (
                  <>
                    <dt>Payment Processing Mode</dt>
                    <dd className={styles.offline}>
                      <Box>
                        <Typography>Online First</Typography>
                        <Switch checked={safMode === 2} onChange={handleOnSafToggle} />
                        <Typography>Offline Only</Typography>
                      </Box>
                    </dd>
                    <dd>
                    <Typography>
                      {safMode === 2
                        ? 'All payments will be taken offline and processed once back online.'
                        : 'Payments will be processed online when possible.'}
                    </Typography>
                    </dd>
                  </>
                )}
                {!DeviceSubtypes.isKiosk(deviceSubtype) && (
                  <>
                    <dt>Maintenance Mode</dt>
                    <dd>
                      <Typography>
                        <p>{safIsUploading
                          ?  'SAF is uploading, no payments will be automatically removed from the card reader.' :
                          'Payments will be automatically removed from the card reader after a certain time.'}</p>
                        <p>Last maintenanced at: {maintenancedAt ? maintenancedAt.toString() : 'NEVER'}</p>
                      </Typography>
                    </dd>
                  </>
                )}

                <dt>SAF Error Message</dt>
                <dd>{safResponse?.success ? 'N/A' : (safResponse?.message ?? 'N/A')}</dd>
                <dt className={cn({ [styles.configError]: !storeIdMatches })}>Store ID </dt>
                <dd>{storeId}</dd>
                <dt className={cn({ [styles.configError]: !terminalIdMatches })}>Terminal ID</dt>
                <dd>{terminalId}</dd>
                <dt className={cn({ [styles.configError]: !esKeyMatches })}>ES Key</dt>
                <dd>{esKey}</dd>
                <dt className={cn({ [styles.configError]: !serviceURLMatches })}>Service URL</dt>
                <dd>{serviceURL}</dd>
                { deviceType === 'pax' &&
                  <dt>Full Card Reader Response</dt>
                }
                { deviceType === 'pax' &&
                  <dd>{JSON.stringify(safFullResponse, null, 2)}</dd>
                }
              </dl>
              <Button
                className={styles.cardReaderConfiguration}
                onClick={onClickCardReaderCondfiguration}
              >
                Card Reader Configuration
              </Button>
              {/* {deviceType === 'fcc' &&
                <Button
                  className={styles.cardReaderConfiguration}
                  onClick={onClickViewLogs}
                >
                  View Logs
                </Button>
              } */}

            </div>
          </div>

        </div>
      )}

      {/* Software View */}

      {!toggle && (
        <div className={classNames}>
          <div className={styles.row}>
            <div className={styles.column}>
              <dl>
                <h3 className={styles.cardReaderConfigurationHeader}>
                  Software
                </h3>


                <dt>Organization</dt>
                <dd>{process.env.REACT_APP_ORG || 'unknown'}</dd>
                <dt>App Version</dt>
                <dd>{process.env.REACT_APP_VERSION || 'unknown'}</dd>

                <dt>App Build Info</dt>
                <dd>{buildInfo || 'unknown'}</dd>

                <dt>Websocket Info</dt>
                <dd>{JSON.stringify(websocketInfo) || 'unknown'}</dd>


              </dl>
            </div>
            <div className={styles.column}>
              <dl>
                <h3 className={styles.cardReaderConfigurationHeader}>
                  Access Token
                </h3>
                <dt>Subject</dt>
                <dd>{tokenPayload.sub}</dd>

                <dt>Expiration Time</dt>
                <dd>{moment.unix(tokenPayload.exp).toString()}</dd>

                <dt>Token ID (JTI)</dt>
                <dd>{tokenPayload.jti}</dd>

                <dt>Audience</dt>
                <dd>{tokenHeader.aud}</dd>

                <dt>Latest Error</dt>
                <dd>{JSON.stringify(errorInfo)}</dd>
              </dl>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  const config = get(state, 'config.configuration', {})
  const firmwareInfo = getFirmwareInfo(state, { json: false })
  const buildInfo = getBuildInfo(state, { json: false })
  const terminalInfo = getTerminalInfo(state, { json: false })
  const secondaryDeviceId = getTerminalInfo(state).serialNumber
  const deviceType = getPaymentType(state)
  const deviceSubtype = getDeviceSubtype(state)
  const maintenancedAt = getMaintenancedAt(state)
  const safResponse = getSafResponse(state)
  const safIsUploading = getSafIsUploading(state)
  const errorInfo = getErrorInfo(state)
  const safFullResponse = getSafFullResponse(state)


  return { config, firmwareInfo, buildInfo, terminalInfo, secondaryDeviceId, deviceType,
    deviceSubtype, maintenancedAt, safResponse, safIsUploading, errorInfo, safFullResponse }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadConfig: () => dispatch(loadConfig()),
    updateConfig: (params) => dispatch(updateConfig(params)),
    onBuildInfoReceived: (payload) => dispatch(onBuildInfoReceived(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DebugInfo)
